import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
const modules = [{
  name: 'CJI Core',
  desc: 'Foundational reasoning and judgment assessment.'
}, {
  name: 'NCJI Youth',
  desc: 'Developmental support for early education.'
}, {
  name: 'NCJI Pathways',
  desc: 'Workforce readiness and opportunity alignment.'
}, {
  name: 'NCJI Civic',
  desc: 'Community resilience and manipulation resistance.'
}, {
  name: 'NCJI Service',
  desc: 'Integrity and systems reasoning for the public sector.'
}, {
  name: 'NCJI Executive',
  desc: 'Crisis reasoning and governance readiness.'
}, {
  name: 'NCJI Atlas',
  desc: 'Aggregate capability mapping for institutions.'
}];
export function ProductEcosystem() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-1319" data-mp="2wmudy53060up">
      <div className="mb-12" data-id="element-1320" data-mp="30o5uzm7t9dra">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-1321" data-mp="30nebh9rhn6hd">
          Assessment &amp; Development Modules
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1322" data-mp="ynwgfz0hq4pu">
          Within the Human Capability Framework
        </h2>
        <p className="mt-4 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-1323" data-mp="tni96j6pqysv">
          The framework combines assessment methods, development pathways, and
          supporting services. These are proposed modules within CJI and NCJI. Each would
          require validation for its intended use before consequential
          application.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1324" data-mp="ay255lvtko7p">
        {modules.map(module => <li key={module.name} className="bg-surface-card p-6 rounded-lg border border-line flex flex-col h-full" data-id="element-1325" data-mp="60a86dgbibwn">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-1326" data-mp="1x43ha8usssa">{module.name}</h3>
            <p className="text-sm text-ink-muted" data-id="element-1327" data-mp="3t4gk9o5tr47o">{module.desc}</p>
          </li>)}
      </ul>

      <motion.div {...fadeUp} className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line pt-12" data-id="element-1328" data-mp="3jerhv7qg2jg9">
        <div className="lg:col-span-5" data-id="element-1329" data-mp="39iene7n2s1kg">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1330" data-mp="39jgaxbla2gj2">Noetivra · Coming soon</p>
          <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-tight" data-id="element-1331" data-mp="3eiau4en5q73p">
            Use the framework through Noetivra
          </h3>
        </div>
        <div className="lg:col-span-7" data-id="element-1332" data-mp="b09f9lj9vw41">
          <p className="text-lg text-ink-dark leading-relaxed mb-6" data-id="element-1333" data-mp="az7uuqgd9x9n">
            Noetivra’s Human Capability Edition would provide the interactive
            workspace for completing tasks, reviewing findings, exploring
            development activities, and following progress over time. SKP would
            maintain the approved definitions, research, and versioned
            knowledge supporting that work.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-1334" data-mp="tsttbwubbwns">
            <a href="/noetivra#human-capability-edition" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1335" data-mp="2eg4ogoj9qqrx">
              Human Capability Edition
              <ArrowRight size={16} aria-hidden="true" data-id="element-1336" data-mp="2j7mggn3bdh0r" />
            </a>
            <a href="/semantic-knowledge" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1337" data-mp="1vijytf8ojo69">
              Semantic Knowledge Platform
              <ArrowRight size={16} aria-hidden="true" data-id="element-1338" data-mp="24kt4nrt06tdb" />
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}